import { error } from '@react/react-spectrum/Toast/js/ToastContainer';
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';

import { commonApi, excApi, handleApiCall } from '@exchange-frontends/api';
import { useIsMounted } from '@exchange-frontends/custom-hooks';

import { useStore } from '../../../store';
import { UserDataContext } from '../../App';
import AcquireAppButton from './AcquireAppButton';
import { HeaderButtonsContext } from './HeaderButtons';

const CcTrialAppButton = () => {
  const { accessToken } = useContext(UserDataContext);
  const { id } = useParams();
  const { fetchCreativeCloudLink, setShowPluginAcquiredDialog } = useContext(HeaderButtonsContext);
  const detailScreen = useStore((state) => state.detailScreen);
  const versionId = detailScreen?.appVersionId;
  const trialInfo = detailScreen?.trialInfo;
  const isMounted = useIsMounted();

  const getTrialVersionId = async () => {
    const handler = handleApiCall(commonApi.ccesV3Extensions, {
      appId: trialInfo.linkedAppId,
      resultType: 'details',
      authToken: accessToken,
    });
    try {
      const trialDetailsResponse = await handler.run();
      return trialDetailsResponse?.apps[0]?.appVersionId;
    } catch (err) {
      console.error(err);
      if (isMounted.current) {
        error(err.userMessage, { timeout: 0 });
      }
    }
  };

  const handleTrial = async () => {
    const trialId = trialInfo.isTrial ? id : trialInfo.linkedAppId;
    const trialVersion = trialInfo.isTrial ? versionId : await getTrialVersionId();
    if (!trialVersion) {
      return;
    }
    const handler = handleApiCall(excApi.createFreeEntitlements, {
      source: 'Exchange',
      accessToken,
      appId: trialId,
      versionId: trialVersion,
    });
    await handler.run();
    if (isMounted.current) {
      if (trialInfo.isTrial) {
        useStore.setState({ acquired: true });
      } else {
        useStore.setState({ trialAppAcquired: true });
      }
      await fetchCreativeCloudLink('install');
      setShowPluginAcquiredDialog(true);
    }
  };

  return <AcquireAppButton type="trial" onPress={handleTrial} />;
};

export default CcTrialAppButton;
